import fetch from './index'

export function getHistoryLog(params): any {
  return fetch.get('/histories/log/list', {params})
}

export function getHistoryTypes() {
  return fetch.get('/histories/log/types')
}